<template>
  <div id="app">
    <!-- <cookie-law
      :theme="'dark-lime--rounded'"
      :buttonDecline="false"
      :buttonDeclineClass="'Cookie__button--decline-red'"
      v-on:accept="updateAllowCookies(true)"
      v-on:decline="updateAllowCookies(false)"
    >
      <div slot="message">
        This website uses cookies to ensure you get the best experience on our
        website.
        <a target="_blank" href="https://pinwall.io/cookiespolicy">More info</a>
      </div>
    </cookie-law> -->
    <router-view :key="$route.fullPath" />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getCookieValue } from "./utils/helpers";
import { goTo } from "./mixins/goTo.js";

export default {
  computed: {
    ...mapGetters(["user", "allowCookies", "darkMode"])
  },
  mixins: [goTo],
  methods: {
    ...mapActions(["getIdentity", "loadTenant", "loadTenants"]),
    ...mapMutations([
      "setUser",
      "setCurrentScrollPosition",
      "setTenant",
      "setAllowCookies"
    ])
  },
  watch: {
    $route() {
      this.loadTenant(this.$route.params.tenant || "pinwall");
    }
  },
  mounted() {
    // Set window title
    window.document.title = "Pinwall";

    let token = getCookieValue("token");
    let identiyErrorMessage = getCookieValue("identiyErrorMessage");
    let identiyInfoMessage = getCookieValue("identiyInfoMessage");

    //Read token from cookie
    if (token && token !== "") {
      this.getIdentity(token).then(() => {
        setInterval(() => {
          this.getIdentity(token);
        }, 60 * 1000);
      });
    } else if (identiyInfoMessage && identiyInfoMessage !== "") {
      this.setUser(null);
      this.$buefy.toast.open({
        message: unescape(this.$t(identiyInfoMessage)),
        type: "is-info",
        duration: 4000,
        position: "is-top-right"
      });
    } else if (identiyErrorMessage && identiyErrorMessage !== "") {
      this.setUser(null);
      this.$buefy.toast.open({
        message: unescape(this.$t(identiyErrorMessage)),
        type: "is-danger",
        duration: 4000,
        position: "is-top-right"
      });
    } else if (this.user && this.user.refresh_token) {
      this.getIdentity(this.user.refresh_token);
      setInterval(() => {
        if (this.user && this.user.refresh_token) {
          this.getIdentity(this.user.refresh_token);
        }
      }, 60 * 1000);
    }
  },
  beforeCreate: function() {
    if (window.location.href.indexOf("#_=_") > 0) {
      window.location = window.location.href.replace(/#.*/, "");
    }
  },
  created: function() {
    if (!localStorage.getItem("appLanguage")) {
      const languagdeCode = navigator.language
        ? navigator.language.slice(0, 2)
        : process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en";
      localStorage.setItem("appLanguage", languagdeCode);
      this.$i18n.locale = languagdeCode;
    } else {
      this.$i18n.locale = localStorage.getItem("appLanguage");
    }

    this.loadTenants();
    const _this = this;
    window.addEventListener("beforeunload", () => {
      _this.setCurrentScrollPosition(0);
    });

    if (this.darkMode) {
      document.getElementsByTagName("html")[0].classList.add("dark");
    } else {
      document.getElementsByTagName("html")[0].classList.remove("dark");
    }
  }
};
</script>

<style lang="scss">
@import "assets/styles/main.scss";
</style>
